import { ColumnDef } from "@tanstack/react-table";
import type { EnrichedIcmStatement } from "@/icm/types";

const TechnicianNameCol: ColumnDef<EnrichedIcmStatement, unknown> = {
  accessorKey: "technician_name",
  header: "Technician",
  meta: { size: "180px" },
  cell: ({ getValue }) => (getValue() as string | null) ?? "-",
};

export default TechnicianNameCol;
